jQuery(document).ready(function ($) {
	
	jQuery('.m-search__button a').on("click", function () {
        event.preventDefault()
		jQuery(this).toggleClass('active'); 
		jQuery('.m-search__wrap').fadeToggle();
		jQuery('.m-search input[type="text"]').focus();  
	});
	jQuery('.m-search__close').on("click", function () {
		jQuery('.m-search__wrap').fadeOut(); 
	});
});